import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import * as CryptoJS from 'crypto-js';
import { Observable } from 'rxjs';
import Swal from 'sweetalert2';
import { CommonService } from '../../../../shared/common.service';
import { SideNavService } from '../../../../theme/layout/admin/navigation/service/side-nav.service';
import { CompanyServiceService } from '../../../company/companylist/company-service.service';
import { AccountingPeriodService } from '../../accounting-period/services/accounting-period.service';
import { GeneralinformationService } from './generalinformation.service';
@Component({
  selector: 'app-generalinformation',
  templateUrl: './generalinformation.component.html',
  styleUrls: ['./generalinformation.component.scss']
})
export class GeneralinformationComponent implements OnInit {
  infoform: FormGroup; companydata: any; defaultstatement: string; countrydata: any
  dataform: any; isJump: any;
  APPeriodId: any;
  limitedby: any;
  limitedname: any;
  leaglformId: any;
  address: any
  address2: any
  address3: any
  address4: any
  postcode: any
  countycode: any;
  NormalRoutng: boolean;
  showBubbledata:any
  constructor(private formbuilder: FormBuilder, public informationservice: GeneralinformationService, public commonService: CommonService,
    public router: Router, public accountsService: AccountingPeriodService, public companyService: CompanyServiceService, public sidenav: SideNavService) { }

  ngOnInit() {
    debugger
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8);
    this.commonService.getIncomeStatementsHeaders();
    this.getAccPeriodInformation()
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8);
    this.commonService.getIncomeStatementsHeaders();
   // this.getCompanyInformation()
    this.createinformation();
    this.isJump = localStorage.getItem('isJump');
    this.getinformation(this.APPeriodId)
    this.commonService.Showbubble.subscribe((data) => {
      if (data) {
        this.commonService.getImportPageSelectionData(this.commonService.AccountTemplateId, CryptoJS.AES.decrypt(localStorage.getItem("companyId"), "APS").toString(CryptoJS.enc.Utf8), CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)).subscribe((data) => {
          this.commonService.showBubble = data[0].ImportStatus
          if (this.commonService.showBubble) {
            this.sidenav.setShowBubble(true);
            this.getlastyearinfo()
          }
        })
      }
      else {
        this.showBubbledata=null
      }
    })
    if (localStorage.getItem("SubmitStatus") == "true")
      this.infoform.disable()
     
    
  }

  getAccPeriodInformation() {
    let AccPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)
    this.companyService.getAccPeriod(AccPeriodId).subscribe((data: any) => {
      this.limitedby = data.CompanyLimitedby
      if (this.limitedby == 1) {
        this.limitedname ="shares"
      } else {
        this.limitedname = "Gurantee"
      }
      this.getCompanyInformation()
    })
  }

  getCompanyInformation() {
    debugger
    var companyId = CryptoJS.AES.decrypt(localStorage.getItem("companyId"), "APS").toString(CryptoJS.enc.Utf8)
    this.commonService.leaglformId = CryptoJS.AES.decrypt(localStorage.getItem("legalFormId"), "APS").toString(CryptoJS.enc.Utf8);
    this.companyService.getCompany(companyId).subscribe((data: any) => {
      if (data) {
        this.companydata = data;
        this.address = data.CompanyAddressLine1 ? data.CompanyAddressLine1 : ""
        this.address2 = data.CompanyAddressLine2 ? data.CompanyAddressLine2 : ""
        this.address3 = data.CompanyAddressLine3 ? data.CompanyAddressLine3 : ""
        this.address4 = data.CompanyAddressLine4 ? data.CompanyAddressLine4 : ""
        this.postcode = data.CompanyPostCode ? data.CompanyPostCode : ""
        this.countycode = data.Countryorregion ? data.Countryorregion : ""
        this.countrydata = this.commonService.countryData;
        var country = this.countrydata.filter((x) => x.CountryId == data.CountryFormationOrIncorporation);
        this.dataform = this.commonService.companyLegalformdata;
         var formdata = this.dataform.filter((x) => x.LegalFormId == +this.commonService.leaglformId);
        this.leaglformId = formdata[0].LegalFormId
        if (this.leaglformId == 1) {
          debugger
          if (country[0] != undefined)
            this.defaultstatement = data.CompanyName + " is a " + formdata[0].LegalFormName + ", Limited By " + this.limitedname + ", registered in " + ((country[0] == undefined || country[0].CountryName == null) ? "" : country[0].CountryName) + ", registration number " + data.CompanyRegistrationNumber + " \n".concat(this.address == "" ? "" : this.address + "  \n").concat(this.address2 == "" ? "" : this.address2 + "  \n").concat(this.address3 == "" ? "" : this.address3 + "  \n").concat(this.address4 == "" ? "" : this.address4 + "  \n").concat(this.countycode == "" ? "" : this.countycode + "  \n").concat(this.postcode == "" ? "" : this.postcode + "  \n")
          else
            this.defaultstatement = data.CompanyName + " is a " + formdata[0].LegalFormName + ", Limited By " + this.limitedname + ", registration number " + data.CompanyRegistrationNumber + " \n".concat(this.address == "" ? "" : this.address + "  \n").concat(this.address2 == "" ? "" : this.address2 + "  \n").concat(this.address3 == "" ? "" : this.address3 + "  \n").concat(this.address4 == "" ? "" : this.address4 + "  \n").concat(this.countycode == "" ? "" : this.countycode + "  \n").concat(this.postcode == "" ? "" : this.postcode + "  \n")

        }
        else {
          if (country[0] != undefined )
            this.defaultstatement = data.CompanyName + " is a " + formdata[0].LegalFormName + ", registered in " + ((country[0] == undefined || country[0].CountryName == null) ? "" : country[0].CountryName) + ", registration number " + data.CompanyRegistrationNumber + "  \n".concat(this.address == "" ? "" : this.address + "  \n").concat(this.address2 == "" ? "" : this.address2 + "  \n").concat(this.address3 == "" ? "" : this.address3 + "  \n").concat(this.address4 == "" ? "" : this.address4 + "  \n").concat(this.countycode == "" ? "" : this.countycode + "  \n").concat(this.postcode == "" ? "" : this.postcode + "  \n")
          else
            this.defaultstatement = data.CompanyName + " is a " + formdata[0].LegalFormName + ", registration number " + data.CompanyRegistrationNumber + "  \n".concat(this.address == "" ? "" : this.address + "  \n").concat(this.address2 == "" ? "" : this.address2 + "  \n").concat(this.address3 == "" ? "" : this.address3 + "  \n").concat(this.address4 == "" ? "" : this.address4 + "  \n").concat(this.countycode == "" ? "" : this.countycode + "  \n").concat(this.postcode == "" ? "" : this.postcode + "  \n")

        }
        this.infoform.controls['TextComment'].setValue(this.defaultstatement);
      }
    })
  }


  createinformation() {
    this.infoform = this.formbuilder.group({
      APPeriodId: new FormControl(),
      GeneralInformationId: new FormControl(),
      TextComment: new FormControl(this.defaultstatement),
      CreatedBy: new FormControl(this.defaultstatement),
    })
  }

  insert() {
    debugger
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8);
    this.infoform.controls['APPeriodId'].setValue(this.APPeriodId);
    this.infoform.controls['CreatedBy'].setValue(localStorage.getItem('LoginuserId'));
    const formdata = this.infoform.getRawValue();
    this.informationservice.addinformation(formdata).subscribe((data) => {
      this.infoform.markAsPristine();
      if (this.NormalRoutng)
        return true;
      var nextPage;
      nextPage = this.commonService.getNextNoteSelection("General Information", this.commonService.NotesList)
      if (this.isJump == 'true')
        this.router.navigate(['/notes'])
      else if (nextPage == 'generalinformation') {
        nextPage = this.commonService.getNextPageSelection("Notes", this.commonService.allPagesdata)
        this.router.navigate([nextPage]);
      }
      else {
        this.router.navigate([nextPage]);
      }
    })
  }

  getinformation(APPeriodId) {
    debugger
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8);
    this.informationservice.getinformation(this.APPeriodId).subscribe((data: any) => {
      this.infoform.controls['TextComment'].setValue(this.defaultstatement);
      this.commonService.getNotesData();
    })
  }
  getlastyearinfo() {
    this.informationservice.getinformation(this.APPeriodId).subscribe((data: any) => {
      this.showBubbledata=data
    })
  }

  back() {
    debugger;
    this.infoform.markAsPristine();
    localStorage.setItem("Backbutton", "true");
    var backpage;
    backpage = this.commonService.getBackSelection("General Information", this.commonService.NotesList)

    if (this.isJump == 'true')
      this.router.navigate(['/notes'])
    else if (backpage == 'generalinformation') {
      this.router.navigate(['/notes']);
    }
    else {
      backpage = this.commonService.getBackSelection("General Information", this.commonService.NotesList)
      this.router.navigate([backpage]);
    }
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    debugger;
    if (this.infoform.dirty) {
      return Swal.fire({
        title: "Andica Accounts Production",
        html: "<span style='font-weight: 900'>You have unsaved data.</span> <br>Do you want to save your changes before leaving?",
        icon: "warning",
        confirmButtonText: "Save Changes",
        showCancelButton: true,
        cancelButtonText: "Discard Changes",
        allowOutsideClick: false
      }).then((result) => {
        if (result.value) {
          this.NormalRoutng = true;
          this.insert();
          return true;
        }
        else {
          return true;
        }
      })
    }
    else if (this.commonService.routeToCompanyList) {
      return true
    }
  }

  TotalBack() {
    debugger;
    this.commonService.DisplayAccountingPeriodlist = true;
    this.router.navigate(['/business']);

  }


}
